import { render, staticRenderFns } from "./providerList.vue?vue&type=template&id=804245cc&scoped=true&"
import script from "./providerList.vue?vue&type=script&lang=js&"
export * from "./providerList.vue?vue&type=script&lang=js&"
import style0 from "./providerList.vue?vue&type=style&index=0&id=804245cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804245cc",
  null
  
)

export default component.exports